import React from 'react'

function MusicAttribution() {
    return (
        <div className='infoPopUp-musicAttribution'>
            <p className="infoPopUp_text">
                "Cool Vibes", "Sidewalk Shade", "Spy Glass", "Backbay Lounge", "Poppers and Prosecco", "Deadly Roulette", "In Your Arms", "Rollin at 5", "George Street Shuffle", "Bass Walker", "Covert Affair", "Faster Does It", "Dances and Dames", "Fast Talkin", "Hot Swing", "I Knew A Guy", "On The Cool Side", "Shades Of Spring", "Walking Along" - by Kevin MacLeod (incompetech.com). Licensed under Creative Commons: By Attribution 4.0 License.
            </p>
            <a 
                href='http://creativecommons.org/licenses/by/4.0/' 
                target='_blank' 
                rel='noreferrer'
            >
                Link To License
            </a><br />
            <a href='https://incompetech.filmmusic.io/song/3828-grim-idol' target='_blank' rel='noreferrer'>Grim Idol by Kevin MacLeod</a> 
            <a 
                href='https://filmmusic.io/standard-license' 
                target='_blank' 
                rel='noreferrer'
            >
                Link To License
            </a>
        </div>
    )
}

export default MusicAttribution